
<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div class="text-center">
        <img
          class="image-responsive textcenter admin_logo mb-8"
          src="@/assets/images/logo/hobi_logo.png"
        />
      </div>
      <form @submit.prevent="sendLink()" autocomplete="off">
        <vx-card>
          <div slot="no-body" class="page-bg-color p-8">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2 inner_image">
                <img
                  src="@/assets/images/full-pages/Login.png"
                  alt="forget"
                  class="mx-auto"
                />
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-8">{{ $t("labels.reset_password") }}</h4>
                  </div>

                  <div>
                    <div class="password-field">
                      <vs-input
                        ref="password"
                        v-validate="{
                          required: true,
                          min: 8,
                          max: 20,
                          regex:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                        }"
                        maxlength="20"
                        :type="passwordfieldtypeNew"
                        class="w-full password-field"
                        name="password"
                        icon-pack="feather"
                        icon="icon-lock"
                        icon-no-border
                        :label-placeholder="$t('labels.new_password')"
                        v-model="n_password"
                      />
                      <button
                        tabindex="-1"
                        type="button"
                        @click="switchVisibilityNew"
                        :class="
                          passwordfieldtypeNew == 'password'
                            ? 'eyeclose'
                            : 'eyeopen'
                        "
                        style="cursor: pointer"
                      ></button>
                    </div>
                    <span class="text-danger text-sm">{{
                      errors.first("password")
                    }}</span>
                    <div class="password-field">
                      <vs-input
                        :type="passwordfieldtype"
                        maxlength="20"
                        class="w-full mt-8 password-field"
                        v-validate="'required|confirmed:password'"
                        name="password_confirmation"
                        icon-pack="feather"
                        icon="icon-lock"
                        icon-no-border
                        :label-placeholder="$t('labels.confirm_password')"
                        v-model="c_password"
                      />
                      <button
                        type="button"
                        @click="switchVisibility"
                        :class="
                          passwordfieldtype == 'password'
                            ? 'eyeclose'
                            : 'eyeopen'
                        "
                        style="cursor: pointer"
                      ></button>
                    </div>
                    <span class="text-danger text-sm">{{
                      errors.first("password_confirmation")
                    }}</span>
                    <div class="mt-5 forget_link">
                      <vs-button
                        :disabled="button_loading"
                        id="forgot-password"
                        button="submit"
                        class="
                          vs-component vs-button
                          float-right
                          px-4
                          w-full
                          md:w-auto
                          mb-8
                          md:mt-0 md:mb-0
                          vs-button-primary vs-button-filled
                        "
                        >{{ $t("labels.submit") }}</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      n_password: "",
      c_password: "",
      passwordfieldtype: "password",
      passwordfieldtypeNew: "password",
      email: localStorage.getItem("admin-email"),
    };
  },

  mounted() {
    localStorage.setItem("reset-password-visited", true);
    this.setValidationMessage();
    if (!localStorage.getItem("change-password")) {
      this.$router.push("/admin/login");
    }
    document.addEventListener("backbutton", this.goToLogin, false);
  },
  beforeDestroy() {
    document.removeEventListener("backbutton", this.goToLogin);
  },
  methods: {
    sendLink() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader(true, "#forgot-password");
          let input = {
            email: this.email,
            password: this.n_password,
            password_confirmation: this.c_password,
          };
          axios
            .post("user/resetPassword", input)
            .then((response) => {
              this.button_loader(false, "#forgot-password");
              let data = response.data;
              this.$vs.notify({
                text: data.message,
                color: "success",
                position: "top-right",
              });
              localStorage.removeItem("auth");
              this.$router.push({ name: "Login" });
            })
            .catch((e) => {
              this.showError(e, "#forgot-password");
            });
        }
      });
    },
    switchVisibility() {
      this.passwordfieldtype =
        this.passwordfieldtype === "password" ? "text" : "password";
    },
    switchVisibilityNew() {
      this.passwordfieldtypeNew =
        this.passwordfieldtypeNew === "password" ? "text" : "password";
    },
    goToLogin() {
      alert("HEY");
    },
  },
};
</script>

<style lang="scss">
</style>
